/* eslint-disable */

import { getOneTrustCookies } from '../OneTrust';

export const loadNewRelicScript = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.defer = true;
  script.src = '/newrelic-tracker.js';
  document.head.appendChild(script);
};

export const logNewrelicAddPageAction = (eventName, eventData) => {
  if (window.newrelic) {
    newrelic.addPageAction(eventName, eventData);
  } else {
    console.log('New Relic script not loaded, or consent not given.');
  }
};

export const handleNewRelicInitBasedOnCookiePreference = () => {
  const oneTrustCookiePreferences = getOneTrustCookies();
  
  if (!oneTrustCookiePreferences) return;
  const { StrictlyNecessary, Performance, Functional, AcceptAll } = oneTrustCookiePreferences;

  // Define cookie preference scenarios for clarity
  const rejectAllExceptNecessary = StrictlyNecessary && !Performance && !Functional;
  const rejectPerformance = StrictlyNecessary && !Performance && Functional;
  const rejectFunctional = StrictlyNecessary && Performance && !Functional;

  // Handle actions based on cookie preferences
  if (AcceptAll) {
    // User has accepted all cookies
    loadNewRelicScript();
  } else if (rejectAllExceptNecessary) {
    // User has rejected all cookies except essential/strictly necessary ones
    // Do not initialize New Relic
  } else if (rejectPerformance) {
    // User has rejected performance cookies but accepted functional and essential
    loadNewRelicScript(); // Initialize with only functional and essential cookies
  } else if (rejectFunctional) {
    // User has rejected functional cookies but accepted performance and essential
    loadNewRelicScript(); // Initialize with only performance and essential cookies
  }
};
